import { Component, h, Host, Prop, State, Watch } from '@stencil/core'
import { random } from 'lodash-es'
import { gsap } from 'src/lib/gsap'

@Component({
  tag: 'ui-pie-loader',
})
export class Loader {
  @Prop() progress = 0
  @Prop() mockSeconds: number

  timeline: gsap.core.Timeline

  @State() tweenedProgress = this.progress

  @Watch('progress')
  onProgress() {
    this.tweenedProgress = this.progress
  }

  get path() {
    let angle = 360 * this.tweenedProgress
    angle %= 360
    const r = (angle * Math.PI) / 180
    const x = Math.sin(r) * 125
    const y = Math.cos(r) * -125
    const mid = angle > 180 ? 1 : 0
    return 'M 0 0 v -125 A 125 125 1 ' + mid + ' 1 ' + x + ' ' + y + ' z'
  }

  componentDidLoad() {
    if (this.mockSeconds) {
      const step = 1 / this.mockSeconds
      const minStep = step * 0.2
      const maxStep = step
      this.timeline = gsap.timeline()
      let curPct = 0
      while (curPct < 1) {
        curPct = Math.min(1, curPct + random(minStep, maxStep, true))
        this.timeline.to(this, { tweenedProgress: curPct, ease: 'none' })
      }
      this.timeline.totalDuration(this.mockSeconds)
    }
  }

  disconnectedCallback() {
    if (this.timeline) {
      this.timeline.kill()
    }
  }

  render() {
    return (
      <Host>
        <svg class='fill-current' style={{ width: '1em', height: '1em' }} viewBox='0 0 250 250'>
          <circle cx='125' cy='125' r='125' class='opacity-50'></circle>
          {this.progress === 1 ? (
            <circle cx='125' cy='125' r='125'></circle>
          ) : (
            <path transform='translate(125, 125)' d={this.path} />
          )}
        </svg>
        <slot />
      </Host>
    )
  }
}
